import { Link } from 'react-router-dom';
import { ArrowRight, Eye } from 'lucide-react';
import './PrototypePreviewNotice.css';

export default function PrototypePreviewNotice({ destination = '/writing', canvas = false }) {
  return (
    <aside className="prototype-preview-notice" aria-label="界面预览说明">
      <Eye size={16} aria-hidden="true" />
      <p id="prototype-static-controls"><strong>界面预览</strong><span>示例内容仅供体验；灰色控件仅作展示，不会保存作品或消耗点数。</span></p>
      <Link to={destination}>{canvas ? '打开我的画布' : '打开我的剧本'}<ArrowRight size={14} aria-hidden="true" /></Link>
    </aside>
  );
}
